class FloatingVideoPopup extends HTMLElement {
  connectedCallback() {
    // Move to <body> directly so position:fixed can never get trapped
    // inside a parent with transform/overflow.
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }

    this.dragHandle = this.querySelector('[data-drag-handle]');
    this.closeButton = this.querySelector('.floating-video-popup__close');
    this.isDragging = false;
    this.offsetX = 0;
    this.offsetY = 0;

    this.closeButton.addEventListener('click', () => {
      this.remove();
    });

    this.dragHandle.addEventListener('pointerdown', this.handlePointerDown.bind(this));
    document.addEventListener('pointermove', this.handlePointerMove.bind(this));
    document.addEventListener('pointerup', this.handlePointerUp.bind(this));
  }

  handlePointerDown(event) {
    if (event.target.closest('.floating-video-popup__close')) return;
    this.isDragging = true;
    const rect = this.getBoundingClientRect();
    this.offsetX = event.clientX - rect.left;
    this.offsetY = event.clientY - rect.top;
    this.dragHandle.setPointerCapture(event.pointerId);
  }

  handlePointerMove(event) {
    if (!this.isDragging) return;

    let newLeft = event.clientX - this.offsetX;
    let newTop = event.clientY - this.offsetY;

    const maxLeft = window.innerWidth - this.offsetWidth;
    const maxTop = window.innerHeight - this.offsetHeight;
    newLeft = Math.max(0, Math.min(newLeft, maxLeft));
    newTop = Math.max(0, Math.min(newTop, maxTop));

    this.style.left = newLeft + 'px';
    this.style.top = newTop + 'px';
    this.style.right = 'auto';
    this.style.bottom = 'auto';
  }

  handlePointerUp() {
    this.isDragging = false;
  }
}

customElements.define('floating-video-popup', FloatingVideoPopup);